<template>
    <div>
        <div class="card" >
              <div class="card-header">
                <div class="row">
                   <div class="col-10">
                  <h4 class="card-title"> GÖRÜŞME TAKİP SİSTEMİ </h4>

                </div>
                <div class="col">
                  <button @click="goToNew" class="btn btn-primary btn-round">YENİ KAYIT</button>
                </div>
                </div>
                <div class="row">
                  <div class="col-3">
                     <input  v-model="text" @input="text=text.toUpperCase()" class="form-control" type="search" name="" id="">
                  </div>
                  </div>      
              </div>
              <div class="card-body">
                <div class="table-responsive table-hover table-striped" style=" height: 70vh; overflow-y: scroll;">
                  <table class="table">
                    <thead class=" text-primary">
                      <tr><th>
                        TARİH
                      </th>
                      <th>
                        FİRMA ADI
                      </th>
                      <th>
                       SEKTÖR
                      </th>
                      <th>
                        GÖRÜŞEN
                      </th>
                      <th>
                        TELEFON
                      </th>
                      <th>
                        E POSTA
                      </th>
                      <th>
                         DURUM
                      </th>
                      <th>
                         
                      </th>
                    </tr></thead>
                    <tbody>
                      <tr v-for="(surec, index) in arama" :key="surec.id"  v-if="index < nindex && index>findex">
                        <td>
                         {{surec.tarih}}
                        </td>
                        <td>
                          {{surec.firmaAdi}}
                        </td>
                        <td>
                          {{surec.sektor}}
                        </td>
                        <td>
                          {{surec.gorusen}}
                        </td>
                        <td>
                          {{surec.telefon}}
                        </td>
                        <td>
                          {{surec.email}}
                        </td>
                        <td>
                          {{surec.surecDurumu}}
                        </td>
                        <td>
                          <button @click="deleteSurec([surec.key,index])" class="btn btn-danger btn-round">SİL</button>
                        </td>
                      </tr> 
                 </tbody>
                  </table>
                </div>
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-center">
                    <li class="page-item ">
                      <a v-if="findex>-1" @click="pagepr" class="page-link" href="#" >Geri</a>
                    </li>
                    <li v-show="false" class="page-item"><a class="page-link" href="#">1</a></li>
                    <li class="page-item">
                      <a  @click="pagenext" class="page-link" href="#">İLERİ</a>
                    </li>
                  </ul>
                </nav>
              </div>
           
            </div>
       
    
    </div>
</template>
<script>
import { mapGetters} from "vuex";

export default {
   data(){
    return{
      text : "",
      findex : null,
      nindex : null,
      perpage: 10,
    }
  },
    computed : {
      ...mapGetters(["getSurecler"]),
      arama(){
        this.findex=-1;
        this.nindex=11;
        return this.getSurecler.filter((element) => {
          if(this.text == ""){
            return element
          }else {
            return element.firmaAdi.match(this.text);
          }
        })
      },
      filtered(){

      },
      
    },
     
    methods : {
      goToNew(){
        this.$router.push("/processnew")
      },
      deleteSurec(i){
        console.log(i)
        var r = confirm("SÜREÇ KAYDINI SİLMEK İSTEDİĞİNİZDEN EMİN MİSİNİZ?")
        if (r == true) {
          this.$store.dispatch("deleteSurec", i)
        
        } else {
          
        }
                
      },
      pagenext(nu){
      this.findex=this.findex+this.perpage
      this.nindex=this.nindex+this.perpage
      },
      pagepr(nu){
        this.findex=this.findex-this.perpage
        this.nindex=this.nindex-this.perpage
      },


    },

}
</script>



// WEBPACK FOOTER //
// src/components/process/processTable.vue